import { useTranslations } from '@vocab/react';
import { Box, ContentBlock, Heading, Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { CactusIllustration } from 'src/libs/Illustrations';

import translations from './.vocab';

export const NoResultForNonFilteredSearch: FC = () => {
  const { t } = useTranslations(translations);

  return (
    <ContentBlock width="large">
      <Box
        background="surface"
        paddingY={['xxlarge', 'xlarge']}
        paddingX="gutter"
      >
        <Stack space="xlarge" align="center">
          <CactusIllustration />
          <Stack space="gutter">
            <Heading level="3" align="center">
              {t('No applicants yet')}
            </Heading>
            <Text align="center">
              {t('Check back later to see if you have new applications.')}
            </Text>
          </Stack>
        </Stack>
      </Box>
    </ContentBlock>
  );
};
